import * as yup from 'yup';

export const loginFormValidation = yup.object().shape({
  email: yup.string().required('Email is required').email('Please enter a valid email address'),
  password: yup.string().required('Password is required'),
});

export const FieldNames = {
  emailField: 'email',
  passwordField: 'password',
} as const;

export const FieldLabels = {
  EMAIL: 'EMAIL',
  PASSWORD: 'PASSWORD',
};
